import * as React from 'react';

// Font files can be colocated inside of `app`

export default function Layout({ children }: { children: React.ReactNode }) {
  // Put Header or Footer Here

  return (
    <>
    <meta name="referrer" content="no-referrer-when-downgrade"></meta>
      <div className='flex w-full flex-col items-center'>
        <div className='flex w-full flex-col'>{children}</div>
      </div>
    </>
  );
}
